export const GET_CAREER = 'GET_CAREER'
export const GET_CAREER_PENDING = 'GET_CAREER_PENDING'
export const GET_CAREER_FULFILLED = 'GET_CAREER_FULFILLED'
export const GET_CAREER_REJECTED = 'GET_CAREER_REJECTED'

export const CANDIDATE_INFOS = 'CANDIDATE_INFOS'
export const CANDIDATE_INFOS_PENDING = 'CANDIDATE_INFOS_PENDING'
export const CANDIDATE_INFOS_FULFILLED = 'CANDIDATE_INFOS_FULFILLED'
export const CANDIDATE_INFOS_REJECTED = 'CANDIDATE_INFOS_REJECTED'

export const APPLY_CAREER = 'APPLY_CAREER'
export const APPLY_CAREER_PENDING = 'APPLY_CAREER_PENDING'
export const APPLY_CAREER_FULFILLED = 'APPLY_CAREER_FULFILLED'
export const APPLY_CAREER_REJECTED = 'APPLY_CAREER_REJECTED'
